import firestore from '@react-native-firebase/firestore';
import {useAppSettings} from 'app/components/AppSettings';
import {Property, useProperties} from '../hooks/useDomainData';
import {GuestyListing, useGuestyListings} from '../hooks/useGuestyData';
import {ScrollView, StyleSheet, View} from 'react-native';
import {
  DataTable,
  Subheading,
  Title,
  TouchableRipple,
} from 'react-native-paper';
import Icon from 'react-native-vector-icons/MaterialCommunityIcons';
import {Picker} from '@react-native-picker/picker';
import {useEffect, useState} from 'react';
import {useMutation, useQueryClient} from 'react-query';
import {useAlerts} from 'react-native-paper-alerts';

function GuestyPropertyMatch() {
  const appSettings = useAppSettings();
  const queryClient = useQueryClient();
  const Alert = useAlerts();
  const guestyListings = useGuestyListings();
  const properties = useProperties();
  // guestyListings?.forEach((listing, index) => {
  //   console.log(`guesty listing ${index} ${listing.nickname}`);
  // });

  // Let's separate into matched and unmatched properties for different tables
  const matchedProperties: Property[] = [];
  const unMatchedProperties: Property[] = [];
  properties?.forEach(property => {
    // console.log(`does ${property.propertyName} have a guesty match?`);
    if (property.guestyId !== undefined) {
      // console.log('Property has guesty listing! ' + property.guestyId);
      matchedProperties.push(property);
    } else {
      unMatchedProperties.push(property);
    }
  });
  // console.log('unMatchedProperties count is ' + unMatchedProperties.length);

  // We will store our dropdown state here for use in updating
  // the remaining dropdowns
  const [matchDropdownSelections, setMatchDropdownSelections] = useState<
    string[]
  >([]);

  useEffect(() => {
    // console.log('in useEffect');
    if (
      properties &&
      guestyListings &&
      matchDropdownSelections.length !== unMatchedProperties.length
    ) {
      setMatchDropdownSelections(Array(unMatchedProperties.length).fill(''));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [properties, guestyListings]);

  // console.log(
  //   `current matchDdropDownSelection: ${JSON.stringify(
  //     matchDropdownSelections,
  //     null,
  //     2,
  //   )}`,
  // );

  // Now let's get just guesty listings with no match for a dropdown
  const unMatchedGuestyListings: GuestyListing[] = [];
  guestyListings?.forEach(listing => {
    if (!matchedProperties.find(prop => prop.guestyId === listing._id)) {
      // console.log(`unmatched guesty listing ${listing.nickname}`);
      unMatchedGuestyListings.push(listing);
    } else {
      // console.log(`MATCH for guesty listing ${listing.nickname}`);
    }
  });

  const handleMatchSave = useMutation(
    (property: Property) => {
      // console.log('in handleMatchSave');

      // clean out fund and ref, they should not be saved
      delete property.fund;
      const docId = property.ref.id;
      // @ts-ignore
      delete property.ref;

      return firestore().collection('properties').doc(docId).set(property);
    },
    {
      onSettled: () => {
        // console.log('save succeeded');
        return queryClient.invalidateQueries('properties');
      },
      onError: e => {
        Alert.alert('Error', 'There was an error while saving: ' + e, [
          {text: appSettings.t('OK')},
        ]);
      },
    },
  );

  const loading = !properties || !guestyListings;

  return (
    <>
      <View style={styles.horizontalCentered}>
        <Title style={styles.title}>Guesty Property Matcher</Title>
      </View>
      <ScrollView
        persistentScrollbar={true}
        style={[styles.container, styles.content]}>
        <View style={styles.horizontalCentered}>
          <Subheading style={styles.title}>Unmatched Properties</Subheading>
        </View>
        <DataTable>
          {loading && (
            <DataTable.Row>
              <DataTable.Header>
                <DataTable.Title>loading...</DataTable.Title>
              </DataTable.Header>
            </DataTable.Row>
          )}
          {!loading && (
            <DataTable.Header style={styles.shortHeader}>
              <DataTable.Title style={styles.widerCell}>
                Property
              </DataTable.Title>
              <DataTable.Title style={styles.widerCell}>
                Unmatched Guesty Listings
              </DataTable.Title>
              <DataTable.Title style={styles.smallCell}>Match</DataTable.Title>
            </DataTable.Header>
          )}
          {!loading && unMatchedProperties && unMatchedProperties.length === 0 && (
            <DataTable.Row>
              <DataTable.Cell>
                No unmatched Equity Residences Properties found.
              </DataTable.Cell>
            </DataTable.Row>
          )}
          {!loading &&
            unMatchedProperties &&
            unMatchedProperties.length > 0 &&
            unMatchedProperties.map((property, index) => (
              <DataTable.Row key={property.propertyId}>
                <DataTable.Cell style={styles.widerCell}>
                  {property.propertyName}
                  {!property.active ? ' (inactive)' : ''}
                </DataTable.Cell>
                <DataTable.Cell style={styles.widerCell}>
                  <Picker
                    // eslint-disable-next-line react-native/no-inline-styles
                    itemStyle={{color: 'black'}}
                    onValueChange={(itemValue, _itemIndex) => {
                      // console.log(
                      //   `dropdown ${index} selected ${itemValue}/${_itemIndex}`,
                      // );
                      matchDropdownSelections[index] = itemValue as string;
                      setMatchDropdownSelections(matchDropdownSelections);
                      // console.log(
                      //   `current matchDdropDownSelection: ${JSON.stringify(
                      //     matchDropdownSelections,
                      //     null,
                      //     2,
                      //   )}`,
                      // );
                    }}>
                    <Picker.Item
                      style={{
                        backgroundColor:
                          appSettings.currentTheme.colors.background,
                        color: appSettings.currentTheme.colors.text,
                      }}
                      label="Pick One"
                      value=""
                    />
                    {unMatchedGuestyListings.map(listing => (
                      <Picker.Item
                        key={`${index}:${listing._id}`}
                        label={listing.nickname}
                        value={listing._id}
                      />
                    ))}
                  </Picker>
                </DataTable.Cell>
                <DataTable.Cell style={styles.smallCell}>
                  <TouchableRipple
                    onPress={async () => {
                      // console.log(
                      //   'should save property match ' +
                      //     property.propertyId +
                      //     ' to ' +
                      //     matchDropdownSelections[index],
                      // );
                      property.guestyId = matchDropdownSelections[index];
                      handleMatchSave.mutate(property);
                    }}>
                    <View style={styles.row}>
                      <Icon
                        style={styles.horizontalPad}
                        color={appSettings.currentTheme.colors.primary}
                        name="link"
                        size={20}
                      />
                    </View>
                  </TouchableRipple>
                </DataTable.Cell>
              </DataTable.Row>
            ))}
        </DataTable>
        <View style={styles.horizontalCentered}>
          <Subheading style={styles.title}>Matched Properties</Subheading>
        </View>
        <DataTable>
          {loading && (
            <DataTable.Row>
              <DataTable.Header>
                <DataTable.Title>loading...</DataTable.Title>
              </DataTable.Header>
            </DataTable.Row>
          )}
          {!loading && (
            <DataTable.Header style={styles.shortHeader}>
              <DataTable.Title style={styles.widerCell}>
                Property Name
              </DataTable.Title>
              <DataTable.Title style={styles.widerCell}>
                Guesty Listing Nickname
              </DataTable.Title>
              <DataTable.Title style={styles.smallCell}>
                Unmatch
              </DataTable.Title>
            </DataTable.Header>
          )}
          {!loading && matchedProperties && matchedProperties.length === 0 && (
            <DataTable.Row>
              <DataTable.Cell>
                No Matched Equity Residences Properties found.
              </DataTable.Cell>
            </DataTable.Row>
          )}
          {!loading &&
            matchedProperties &&
            matchedProperties.length > 0 &&
            matchedProperties.map(property => (
              <DataTable.Row key={property.propertyId}>
                <DataTable.Cell style={styles.widerCell}>
                  {property.propertyName}
                </DataTable.Cell>
                <DataTable.Cell style={styles.widerCell}>
                  {
                    guestyListings?.find(
                      listing => listing._id === property.guestyId,
                    )?.nickname
                  }
                </DataTable.Cell>
                <DataTable.Cell style={styles.smallCell}>
                  <TouchableRipple
                    onPress={() => {
                      // console.log(
                      //   'should unmatch property ' + property.propertyId,
                      // );
                      delete property.guestyId;
                      handleMatchSave.mutate(property);
                    }}>
                    <View style={styles.row}>
                      <Icon
                        style={styles.horizontalPad}
                        color={appSettings.currentTheme.colors.primary}
                        name="link-off"
                        size={20}
                      />
                    </View>
                  </TouchableRipple>
                </DataTable.Cell>
              </DataTable.Row>
            ))}
        </DataTable>
      </ScrollView>
    </>
  );
}

const styles = StyleSheet.create({
  shortHeader: {height: 25},
  horizontalPad: {paddingHorizontal: 10},
  row: {flexDirection: 'row'},
  content: {paddingHorizontal: 20},
  center: {alignItems: 'center'},
  touchableRow: {
    paddingHorizontal: 5,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  widerCell: {
    minWidth: 150,
    width: 100,
    justifyContent: 'center',
    alignItems: 'center',
  },
  smallCell: {
    maxWidth: 80,
    width: 40,
    justifyContent: 'center',
    alignItems: 'center',
  },
  borderCell: {
    borderStartWidth: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  container: {
    flex: 1,
    position: 'relative',
  },
  title: {
    padding: 10,
    paddingHorizontal: 20,
  },
  horizontalCentered: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    alignContent: 'center',
    paddingHorizontal: 10,
  },
});

export default GuestyPropertyMatch;
